import React from 'react';
import PropTypes from 'prop-types';

import OENumberInput from '../../controls/oe-number-input';
import {OEObjectModelValueTypes} from '../oe-object-model-value-edit-model';
import OEObjectModelValueCell from './oe-object-model-value-cell';

export default class OEObjectModelNumberValueCell extends React.PureComponent {

    constructor(props) {
        super(props);

        this.isInteger = this.determineIsInteger();
        this.isUnsigned = this.determineIsUnsigned();

        this.state = {
            isInteger:      this.isInteger,
            isUnsigned:     this.isUnsigned,
        };

        this.onChange = this.onChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.type !== nextProps.type)  {
            this.isInteger = this.determineIsInteger();
            this.isUnsigned = this.determineIsUnsigned();
            this.setState({
                isInteger:      this.isInteger,
                isUnsigned:     this.isUnsigned,
            });
        }
    }

    determineIsInteger(props)    {
        props = props || this.props;
        const Types = OEObjectModelValueTypes;
        return [Types.integer, Types.unsignedInteger, Types.integer64, Types.unsignedInteger64].includes(props.type);
    }

    determineIsUnsigned(props)    {
        props = props || this.props;
        const Types = OEObjectModelValueTypes;
        return [Types.unsignedInteger, Types.unsignedInteger64].includes(props.type);
    }

    render()    {
        let min = this.props.min;
        if(this.state.isUnsigned)  min = Math.max(min, 0);

        return (
            <OEObjectModelValueCell {...this.props}>
                <OENumberInput
                    disabled={this.props.disabled}
                    allowUndefined={this.props.allowUndefined}
                    deferMinMaxConstraint={this.props.deferMinMaxConstraint}
                    min={min}
                    max={this.props.max}
                    step={this.state.isInteger ? 1 : this.props.step}
                    value={this.props.value}
                    onChange={this.onChange}
                />
            </OEObjectModelValueCell>
        );
    }

    onChange(sender, value)    {
        if(typeof(value) === 'number' && value < 0 && this.isUnsigned)  {
            value = Math.max(value, 0);
        }
        if(value === this.props.value) return;
        if(this.props.onChange)   this.props.onChange(this, this.props.name, value);
    }
};

OEObjectModelNumberValueCell.defaultProps = Object.assign({
    disabled:                   false,
    allowUndefined:             true,
    deferMinMaxConstraint:      true
}, OEObjectModelValueCell.defaultProps);

OEObjectModelNumberValueCell.propTypes = Object.assign({
    disabled:                   PropTypes.bool,
    allowUndefined:             PropTypes.bool,
    deferMinMaxConstraint:      PropTypes.bool,
    min:                        PropTypes.number,
    max:                        PropTypes.number,
    step:                       PropTypes.number,
    value:                      PropTypes.number,
}, OEObjectModelValueCell.propTypes);